<template lang="">
  <div class='rightConcent' :style='"height:"+height+"px"' :class="title?'padding_top_0':''"> 
    <div class='tableContent' :style='"height:"+height+"px"' ref="scrollContainer"> 
      <div class="flexBox" v-if="title"> 
        <div class="headerTitle">{{ title }}</div> 
        <div class="backBtn" @click="goBack" v-if = 'returnFlag'>返回</div>
      </div> 
    <div class='content' :style='{"height":(title?height-35:height)+"px"}'>
      <router-view v-slot="{ Component }">
        <keep-alive :include="['szgxProductList','szgxRefundOrderList','szgxOrderlist']">
          <component :is="Component" :scrollTop="scrollTop" :scrollContainer="scrollContainer" />
        </keep-alive>
      </router-view>
    </div>
    
  </div> 
    </div>
  </template>
  <script>
  import { ref, watch, onMounted,onUnmounted } from "vue";
  import { useRoute } from "vue-router";
  import router from "@/router";
  export default {
    setup() {
      const returnFlag = ref(false)
      const height = ref(document.documentElement.clientHeight - 71);
      // 监听浏览器尺寸变化
      const goBack = () => {
        router.go(-1);
      };
      
      const scrollContainer=ref(null);
      const scrollTop=ref(0);
      // 定义滚动事件处理函数
      function handleScroll() {
        // 获取当前滚动高度
        if(scrollContainer.value){
          scrollTop.value = scrollContainer.value.scrollTop;
          console.log('当前滚动高度：', scrollTop.value);
        }
      }

      onMounted(() => {
        window.addEventListener("resize", () => {
          // 监听页面尺寸变化
          height.value = document.documentElement.clientHeight - 71;
        });
        // 绑定scroll事件
        scrollContainer.value.addEventListener('scroll', handleScroll);

        if(route.name.list?.length == 4){
            // title.value = (route.name && route.name.title) || "";
            title.value = route.name.list[1] + ' > ' + route.name.list[3]
            returnFlag.value = false
          }else if(route.name.list?.length == 5) {
            returnFlag.value = true
            title.value = route.name.list[1] + ' > ' + route.name.list[3]+ ' > ' + route.name.list[4]
          }else{
            title.value = (route.name && route.name.title) || ""
          }
      });
      onUnmounted(() => {
        if (scrollContainer.value) {
          scrollContainer.value.removeEventListener('scroll', handleScroll)
        }
      })
      const route = useRoute();
      const title = ref("");
      watch(
        () => route.fullPath,
        () => {
          if(route.name.list?.length == 4){
            // title.value = (route.name && route.name.title) || "";
            title.value = route.name.list[1] + ' > ' + route.name.list[3]
            returnFlag.value = false
          }else if(route.name.list?.length == 5) {
            returnFlag.value = true
            title.value = route.name.list[1] + ' > ' + route.name.list[3]+ ' > ' + route.name.list[4]
          }else{
            console.log(route.name)
            title.value = (route.name && route.name.title) || ""
          }
        },
        { deep: true }
      );
      return {
        height,
        title,
        goBack,
        returnFlag,
        scrollContainer,
        scrollTop
      };
    },
  };
  </script>
  <style lang="less" scoped>
  .rightConcent {
    padding: 15px;
    .headerTitle {
      border-left: 3px solid #3e7fff;
      padding-left: 6px;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #000;
      margin: 7px 0 8px;
    }
    .flexBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      .backBtn {
        margin-left: auto;
        width: 46px;
        height: 24px;
        border-radius: 2px;
        border: solid 1px #dbe0ec;
        text-align: center;
        line-height: 24px;
        color: #3e4056;
        font-size: 12px;
        align-self: center;
        cursor: pointer;
      }
    }
    .breadTop {
      margin-bottom: 18px;
    }
    .arco-breadcrumb {
      display: flex;
    }
    .tableContent {
      overflow-y: scroll;
    }
    .tableContent::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  
    .tableContent {
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
      overflow-x: hidden;
      overflow-y: scroll;
    }
  }
  .padding_top_0 {
    padding-top: 0;
  }
  </style>
  